module.exports = __webpack_public_path__ + "static/media/Trading-cards-2021-banner.26751621.jpg";